import {EVMChain} from "@devour/client";
import type {Chain} from "thirdweb/chains";
import {polygon, ethereum, avalanche, mumbai, base} from "thirdweb/chains";

export const parseChain = (chain: EVMChain): Chain => {
    switch (chain) {
        case EVMChain.ETHEREUMMAINNET:
            return ethereum;
        case EVMChain.POLYGON:
            return polygon;
        case EVMChain.AVALANCHE:
            return avalanche;
        case EVMChain.MUMBAI:
            return mumbai;
        case EVMChain.BASE:
            return base;
    }
};

export function getChains(skipTestNets = true) {
    return [
        {
            name: "Ethereum",
            nameShort: "ETH",
            chain: EVMChain.ETHEREUMMAINNET,
        },
        {
            name: "Polygon",
            nameShort: "MATIC",
            chain: EVMChain.POLYGON,
        },
        {
            name: "Avalanche",
            nameShort: "AVAX",
            chain: EVMChain.AVALANCHE,
        },
        ...!skipTestNets ? [
            {
                name: "Mumbai",
                nameShort: "MUMBAI",
                chain: EVMChain.MUMBAI,
            },
        ] : [],
        {
            name: "Base",
            nameShort: "BASE",
            chain: EVMChain.BASE,
        },
        {
            name: "Solana",
            nameShort: "SOL",
            chain: EVMChain.SOLANA,
        },
    ];
}

export function getOpenSeaChainUrl(chain: EVMChain): string {
    switch (chain) {
        case EVMChain.ETHEREUMMAINNET:
            return "ethereum";
        case EVMChain.POLYGON:
            return "matic";
        case EVMChain.AVALANCHE:
            return "avax";
        case EVMChain.MUMBAI:
            return "mumbai";
        case EVMChain.BASE:
            return "base";
        default:
            return chain;
    }
}
